import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    InventoryQuickAddPreviewInput,
    InventoryQuickAddPreviewResponse,
} from '../../types/inventory';

const previewQuickAdd = async (
    input: InventoryQuickAddPreviewInput,
    sessionId: string | null,
): Promise<InventoryQuickAddPreviewResponse> => {
    const { signal, ...body } = input;
    const { data } = await axios.post(`${API_URL}/inventory/quick-add/preview`, body, {
        headers: { Authorization: sessionId },
        signal,
    });
    return data;
};

export const useInventoryQuickAddPreview = (
    options?: UseMutationOptions<
        InventoryQuickAddPreviewResponse,
        unknown,
        InventoryQuickAddPreviewInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: InventoryQuickAddPreviewInput) =>
            previewQuickAdd(input, sessionContext?.sessionId ?? null),
        ...options,
    });
};
